import { useState, useEffect } from "react";
import React from "react";
import {
  Col,
  Container,
  Row,
  Input,
  Button,
  Card,
  CardBody,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import SimpleBar from "simplebar-react";
import find from "../../../assets/find.svg";
import "simplebar/dist/simplebar.min.css";
import { Link } from "react-router-dom";
import { get, put, del } from "../../../api/axios";
import endpoints from "../../../api/endpoints";
import { useNavigate } from "react-router-dom";
import check from "../../../assets/images/check.svg";
import caldropdown from "../../../assets/images/cal-dropdown.svg";
import avatar from "../../../assets/images/personPlaceholder.png";
import moreIcon from "../../../assets/images/more.png";
import { toast, Bounce } from "react-toastify";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Placeholder from "../../../assets/images/Placeholder.gif";
const ListUser = () => {
  document.title = "Active Users | Elevated - Admin Dashboard";
  const [dropdownOpen, setDropdownOpen] = useState({});
  const [usersData, setUsersData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [totalItems, setTotalItems] = useState("");
  const [itemPerPage, setItemPerPage] = useState("");
  const itemsPerPage = 6;
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedType, setSelectedType] = useState("Acc Status");
  const [actionToConfirm, setActionToConfirm] = useState(null);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [accStatus, setAccStatus] = useState("");

  const toggleDropdown = (id) => {
    setDropdownOpen((prevState) => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };

  const fetchUsers = async (
    page,
    searchQuery = "",
    accStatus = "",
    startDate = "",
    endDate = ""
  ) => {
    setLoading(true);
    try {
      const response = await get(
        `${endpoints.user}?filter=active&limit=${itemsPerPage}&page=${page}&accStatus=${accStatus}&search=${searchQuery}&startDate=${startDate}&endDate=${endDate}`
      );

      setUsersData(
        Array.isArray(response.data?.data) ? response.data.data : []
      );
      setTotalPages(response.data?.totalPages || 1);
      setItemPerPage(response.data?.data?.length || 0);
      setTotalItems(response.data?.totalCount || 0);
    } catch (error) {
      setUsersData([]);
    } finally {
      setLoading(false);
    }
  };

  const updateUserStatus = async (id, status) => {
    try {
      let response;
      if (status === "delete") {
        response = await del(`${endpoints.user}/${id}`);
      } else {
        response = await put(`${endpoints.user}/status/${id}`, { status });
      }

      fetchUsers(currentPage, searchTerm);
      switch (status) {
        case "archive":
          toast.success(`User Archived Successfully`, {
            position: "bottom-center",
            theme: "colored",
            transition: Bounce,
          });
          break;
        case "block":
          toast.success(`User Blocked Successfully`, {
            position: "bottom-center",
            theme: "colored",
            transition: Bounce,
          });
          break;
        case "delete":
          toast.success(`User Deleted Successfully`, {
            position: "bottom-center",
            theme: "colored",
            transition: Bounce,
          });
          fetchUsers(currentPage, "");
          break;
        default:
          break;
      }
    } catch (error) {
      console.error(
        `Error ${status === "delete" ? "deleting" : "updating"} user:`,
        error
      );
      toast.error(
        `Failed to ${status === "delete" ? "delete" : "update"} user.`
      );
    } finally {
    }
  };
  const handleAction = (userId, action) => {
    setSelectedUserId(userId);
    setActionToConfirm(action);
  };

  const confirmAction = () => {
    if (selectedUserId && actionToConfirm) {
      updateUserStatus(selectedUserId, actionToConfirm);
      setSelectedUserId(null);
      setActionToConfirm(null);
    }
  };
  useEffect(() => {
    fetchUsers(currentPage, "", accStatus);
  }, [currentPage, accStatus]);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      fetchUsers(currentPage, searchTerm, accStatus);
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [searchTerm]);

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };
  const handleClearFilters = () => {
    setSelectedType("Acc Status");
    setSearchTerm("");
    setCurrentPage(1);
    setAccStatus("");
    setStartDate("");
    setEndDate("");
  };
  return (
    <div>
      <Container fluid>
        <Row className="g-0">
          <Col>
            <Card className="rounded-4">
              <CardBody>
                <div className="d-flex flex-column flex-xl-row justify-content-between align-items-center mb-3">
                  {/* Search Section */}
                  <div className="d-flex flex-column flex-sm-row justify-content-start align-items-center gap-2 w-100 mt-2 mt-sm-0">
                    <span className="font-size-20 fw-bold primary-black flex-nowrap w-50 ff-sora mb-2 mb-sm-0">
                      Active Users
                    </span>
                    <div
                      className="w-100 w-sm-auto mx-sm-3 bg-light ff-sora d-flex justify-content-between align-items-center"
                      style={{ borderRadius: "12px", height: "48px" }}
                    >
                      <img
                        src={find}
                        alt="Search"
                        className="light-black"
                        style={{
                          height: "24px",
                          width: "24px",
                          marginLeft: "10px",
                        }}
                      />
                      <Input
                        type="text"
                        name="search"
                        value={searchTerm}
                        onChange={handleSearchChange}
                        className="ff-sora light-black font-size-14 fw-normal w-100"
                        style={{ background: "transparent", border: "none" }}
                        placeholder="Search"
                      />
                    </div>
                  </div>

                  {/* Filters Section */}
                  <div className="d-flex flex-column flex-sm-row gap-2 w-100 mt-2 mt-xl-0">
                    <div className="d-flex flex-column flex-sm-row gap-2 w-100">
                      {/* Date Range Dropdown */}
                      <Dropdown
                        isOpen={dropdownOpen.dateRange}
                        toggle={() => toggleDropdown("dateRange")}
                        className="w-100 w-md-auto"
                      >
                        <DropdownToggle
                          caret
                          className="filter-btn d-flex justify-content-between align-items-center w-100 w-sm-auto"
                        >
                          <span className="fw-normal ff-sora secondary-black font-size-14 w-100 w-sm-auto">
                            Date Range
                          </span>
                          <img
                            src={caldropdown}
                            alt="Calendar Dropdown"
                            className="ms-2"
                          />
                        </DropdownToggle>
                        <DropdownMenu style={{ zIndex: 2 }} className="p-3">
                          <div className="d-flex flex-column">
                            <span className="mb-2 fw-normal ff-sora secondary-black font-size-14">
                              Start Date
                            </span>
                            <DatePicker
                              selected={startDate}
                              onChange={(date) => {
                                setStartDate(date);
                                if (date && endDate) {
                                  fetchUsers(1, "", "", date, endDate); // Call API only if both dates are selected
                                }
                              }}
                              dateFormat="yyyy/MM/dd"
                              className="form-control fw-normal ff-sora secondary-black font-size-14 mb-3"
                              placeholderText="Select Start Date"
                            />
                            <span className="mb-2 fw-normal ff-sora secondary-black font-size-14">
                              End Date
                            </span>
                            <DatePicker
                              selected={endDate}
                              onChange={(date) => {
                                setEndDate(date);
                                if (startDate && date) {
                                  fetchUsers(1, "", "", startDate, date); // Call API only if both dates are selected
                                }
                              }}
                              dateFormat="yyyy/MM/dd"
                              className="form-control fw-normal ff-sora secondary-black font-size-14"
                              placeholderText="Select End Date"
                            />
                          </div>
                          <button
                            type="button"
                            onClick={handleClearFilters}
                            className="btn btn-link text-danger fw-normal ff-sora font-size-12 mt-2 p-0"
                          >
                            Clear
                          </button>
                        </DropdownMenu>
                      </Dropdown>

                      {/* Type Dropdown */}
                      <Dropdown
                        isOpen={dropdownOpen.byType}
                        toggle={() => toggleDropdown("byType")}
                        className="w-100 w-md-auto"
                      >
                        <DropdownToggle
                          caret
                          className="filter-btn d-flex justify-content-between align-items-center w-100 w-sm-auto"
                        >
                          <span className="w-100 w-sm-auto">
                            {selectedType}
                          </span>
                          <img src={check} alt="Location" className="ms-2" />
                        </DropdownToggle>
                        <DropdownMenu style={{ zIndex: 1 }}>
                          <DropdownItem
                            className="fw-normal ff-sora secondary-black font-size-14"
                            onClick={handleClearFilters}
                          >
                            Acc Status
                          </DropdownItem>
                          <DropdownItem
                            className="fw-normal ff-sora secondary-black font-size-14"
                            onClick={() => {
                              setAccStatus("true");
                              setCurrentPage(1);
                              setSelectedType("Verified");
                            }}
                          >
                            Verified
                          </DropdownItem>
                          <DropdownItem
                            className="fw-normal ff-sora secondary-black font-size-14"
                            onClick={() => {
                              setAccStatus("false");
                              setCurrentPage(1);
                              setSelectedType("Unverified");
                            }}
                          >
                            Unverified
                          </DropdownItem>
                        </DropdownMenu>
                      </Dropdown>
                    </div>
                  </div>
                </div>
                <>
                  <div
                    className="table-responsive hide-scrollbar"
                    style={{
                      height: usersData?.length > 0 ? "500px" : "auto",
                    }}
                  >
                    <Table
                      hover
                      className="table-borderless table-centered table-nowrap"
                    >
                      <thead>
                        <tr>
                          <th className="ff-sora">ID</th>
                          <th className="ff-sora">User</th>
                          <th className="ff-sora">Passes Purchased</th>
                          <th className="ff-sora">Email</th>
                          <th className="ff-sora">Social Link</th>
                          <th className="ff-sora">Account Status</th>
                          <th className="ff-sora">Registered On</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? (
                          <tr>
                            <td colSpan={8} className="text-center">
                              <div className="d-flex justify-content-center align-items-center">
                                <div
                                  className="spinner-border"
                                  style={{
                                    width: "3rem",
                                    height: "3rem",
                                    color: "#3BABA6",
                                  }}
                                  role="status"
                                >
                                  <span className="visually-hidden">
                                    Loading...
                                  </span>
                                </div>
                              </div>
                            </td>
                          </tr>
                        ) : usersData.length === 0 ? (
                          <></>
                        ) : (
                          usersData.map((user, index) => (
                            <tr key={user.id + index}>
                              <td className="ff-sora">
                                {(currentPage - 1) * itemsPerPage + index + 1}
                              </td>
                              <td>
                                <div className="d-flex align-items-center ff-sora">
                                  <img
                                    src={
                                      user.additionalInfo?.profileImage
                                        ? `${process.env.REACT_APP_IMG_URL}${user.additionalInfo.profileImage}`
                                        : avatar
                                    }
                                    alt={`${user.firstName} ${user.lastName} avatar`}
                                    className="avatar-xs rounded-circle object-fit-cover me-2"
                                    width="48"
                                    height="48"
                                    onError={(e) => {
                                      e.target.src = avatar;
                                    }}
                                  />
                                  <div>
                                    <h6 className="font-size-14 mb-1 ff-sora fw-normal secondary-black">
                                      {user.firstName && user.lastName
                                        ? `${user.firstName
                                            .charAt(0)
                                            .toUpperCase()}${user.firstName
                                            .slice(1)
                                            .toLowerCase()} ${user.lastName
                                            .charAt(0)
                                            .toUpperCase()}${user.lastName
                                            .slice(1)
                                            .toLowerCase()}`
                                        : "N/A"}
                                    </h6>
                                  </div>
                                </div>
                              </td>
                              <td className="ff-sora">{user.passes || "0"}</td>
                              <td className="ff-sora">{user.email || "N/A"}</td>
                              <td className="ff-sora">
                                {user.additionalInfo?.sociallink || "N/A"}
                              </td>
                              <td>
                                <span
                                  className={`badge font-size-14 fw-normal py-2 px-2 ff-sora ${
                                    user.emailVerified
                                      ? "bg-soft-success"
                                      : "bg-warning-subtle text-warning"
                                  }`}
                                >
                                  {user.emailVerified
                                    ? "Verified"
                                    : "Un-Verified"}
                                </span>
                              </td>
                              <td className="ff-sora">
                                {user.createdAt
                                  ? new Date(
                                      user.createdAt
                                    ).toLocaleDateString()
                                  : "N/A"}
                              </td>
                              <td>
                                <Dropdown
                                  isOpen={dropdownOpen[user.id] || false}
                                  toggle={() => toggleDropdown(user.id)}
                                  key={user.id}
                                >
                                  <DropdownToggle
                                    tag="button"
                                    className="btn btn-link p-0"
                                  >
                                    <img src={moreIcon} alt="More options" />
                                  </DropdownToggle>
                                  <DropdownMenu
                                    end
                                    className="font-size-14 fw-normal ff-sora"
                                  >
                                    <DropdownItem
                                      onClick={() =>
                                        handleAction(user.id, "delete")
                                      }
                                    >
                                      Delete
                                    </DropdownItem>
                                    <DropdownItem
                                      onClick={() =>
                                        handleAction(user.id, "archive")
                                      }
                                    >
                                      Archive
                                    </DropdownItem>
                                    <DropdownItem
                                      onClick={() =>
                                        handleAction(user.id, "block")
                                      }
                                    >
                                      Block
                                    </DropdownItem>
                                  </DropdownMenu>
                                </Dropdown>
                              </td>
                            </tr>
                          ))
                        )}

                        <Modal
                          isOpen={!!actionToConfirm}
                          toggle={() => setActionToConfirm(null)}
                          className="modal-dialog-centered rounded-4"
                        >
                          <ModalHeader
                            className="font-size-16 fw-medium ff-sora"
                            toggle={() => setActionToConfirm(null)}
                          >
                            Confirm Action
                          </ModalHeader>
                          <ModalBody className="font-size-14 fw-normal ff-sora">
                            Are you sure you want to {actionToConfirm}
                          </ModalBody>
                          <ModalFooter>
                            <Button
                              type="submit"
                              className=" rounded-pill"
                              onClick={confirmAction}
                            >
                              Confirm
                            </Button>
                            <Button
                              color="white"
                              className="rounded-pill1"
                              onClick={() => setActionToConfirm(null)}
                            >
                              Cancel
                            </Button>
                          </ModalFooter>
                        </Modal>
                      </tbody>
                    </Table>
                    {!loading && usersData?.length === 0 && (
                      <div className="d-flex flex-column align-items-center justify-content-center vh-50">
                        <img
                          src={Placeholder}
                          alt="No record placeholder"
                          className="object-fit-contain img-fluid h-25 w-25 rounded-3 mb-3"
                        />
                        <p className="text-center ff-sora font-size-16 fw-normal">
                          No User Found!
                        </p>
                      </div>
                    )}
                  </div>
                </>
              </CardBody>
            </Card>
            <div
              className="d-flex justify-content-between align-items-center"
              style={{
                height: "40px",
                position: "sticky",
                bottom: "0",
                zIndex: "10",
                backgroundColor: "#f5f5f5",
              }}
            >
              <div>
                <span className="font-size-14 mb-1 fw-normal ff-sora secondary-black">
                  {`Showing ${Math.min(
                    (currentPage - 1) * itemsPerPage + itemPerPage
                  )} of ${totalItems}`}
                </span>
              </div>
              <div className="d-flex justify-content-center">
                <Button
                  style={{
                    width: "40px",
                    height: "40px",
                    color: "#1f1f1f",
                    borderWidth: "1px",
                    borderColor: currentPage === 1 ? "#f5f5f5" : "#1f1f1f",
                    background: "#f5f5f5",
                    borderRadius: "80px",
                  }}
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  &lt;
                </Button>
                {[...Array(totalPages).keys()]
                  .slice(
                    Math.max(0, currentPage - 2),
                    Math.min(totalPages, currentPage + 1)
                  )
                  .map((page) => (
                    <Button
                      key={page + 1}
                      onClick={() => handlePageChange(page + 1)}
                      style={{
                        width: "40px",
                        height: "40px",
                        color: currentPage === page + 1 ? "white" : "#1f1f1f",
                        background:
                          currentPage === page + 1 ? "#3BABA6" : "#f5f5f5",
                        marginLeft: "10px",
                        marginRight: "10px",
                        borderRadius: "80px",
                        border: 0,
                      }}
                      className={currentPage === page + 1 ? "active" : ""}
                    >
                      {page + 1}
                    </Button>
                  ))}
                <Button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  style={{
                    width: "40px",
                    height: "40px",
                    color: "#1f1f1f",
                    borderWidth: "1px",
                    borderColor:
                      currentPage === totalPages ? "#f5f5f5" : "#1f1f1f",
                    background: "#f5f5f5",
                    borderRadius: "80px",
                  }}
                >
                  &gt;
                </Button>
              </div>
            </div>
            <div
              className="d-flex justify-content-between align-items-center"
              style={{
                height: "60px",
                position: "sticky",
                bottom: "0",
                zIndex: "10",
              }}
            ></div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ListUser;
